import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sprout, Heart, Gift, EyeOff, Eye, Calendar, Radio, HeartHandshake, Smartphone } from "lucide-react";
import api from "@/lib/api";
import { useFeature } from "@/contexts/FeaturesContext";

/* ── Portofelul de Semințe (17.12) ── */


/*
 * `beforeinstallprompt` e emis de browser devreme, la boot — înainte ca panoul (montat abia
 * după navigarea la /cont) să apuce să înregistreze un listener. Îl capturăm o singură dată,
 * la nivel de modul (rulează la încărcarea bundle-ului), și îl reținem ca să nu-l pierdem.
 */
let deferredPrompt = null;
const promptListeners = new Set();
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    promptListeners.forEach((fn) => fn(e));
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    promptListeners.forEach((fn) => fn(null));
  });
}

/* ── „Instalează aplicația" (PWA) — vs. appurile Răgaz/Medusa, fără App Store ── */
export function PWAInstall() {
  const enabled = useFeature("pwa_install");
  const [prompt, setPrompt] = useState(deferredPrompt);
  const [installed, setInstalled] = useState(false);
  useEffect(() => {
    if (!enabled) return undefined;
    const fn = (e) => { if (e === null) { setInstalled(true); setPrompt(null); } else setPrompt(e); };
    promptListeners.add(fn);
    if (deferredPrompt) setPrompt(deferredPrompt); // eveniment deja capturat înainte de montare
    return () => { promptListeners.delete(fn); };
  }, [enabled]);
  if (!enabled || installed || !prompt) return null;
  const install = async () => {
    try { prompt.prompt(); await prompt.userChoice; setPrompt(null); } catch (e) { /* noop */ }
  };
  return (
    <button type="button" onClick={install} className="card-premium p-5 text-center hover:-translate-y-0.5 transition-transform w-full" data-testid="pwa-install">
      <Smartphone size={22} className="mx-auto mb-2" style={{ color: "var(--ct-link)" }} />
      <p className="text-xs font-medium">Instalează aplicația pe telefon</p>
      <p className="text-[10px] mt-0.5" style={{ color: "var(--ct-text-dim)" }}>Pădurea ta, la un tap distanță — fără App Store.</p>
    </button>
  );
}
